import React from "react";

const QuizOptions = ({ children, className = "" }) => {
  return <div className={`quiz-options ${className}`}>{children}</div>;
};

export default QuizOptions;
